<template>
  <div>
    <div class="atc-wrapper" :class="{ 'hide-border': hideBorder }">
      <div v-if="isTemplated">
        <ProductDetails :active-product="selectedProduct" :product-type="productType" :product-attributes="productAttributes" :fabrics="fabrics" />
      </div>
      <button
        ref="atcButton"
        type="button"
        class="btn--add-to-cart"
        :class="{ disabled: !selectedProduct.available }"
        @click="addToCart"
        :disabled="!selectedProduct.available"
      >
        <span class="btn__text" v-if="selectedProduct.available">
          Add To Cart • {{selectedProduct.price}}
        </span>
        <span class="btn__text" v-else> SOLD OUT </span>
      </button>
      <div ref="promoWrapper" class="promo-component-wrapper">
          
      </div>
      <div class="shipping_length">
        {{ shippingString }}
      </div>
      <div v-if="errorMessage" class="error-message_container">
        <span class="error-message_message">{{ errorMessage }}</span>
      </div>
      <div class="sticky-atc-wrapper" ref="stickyContainer">
        <div class="sticky-atc">
          <div class="sticky-atc-details">
              <div class="sticky-atc-heading">{{productTitle}}</div>
              <div class="sticky-price-dextails">
                <div class="sticky-price-container">
                  <div
                    v-if="!shopifyEmptyPrices.includes(selectedProduct.sPrice) && selectedProduct.sale"
                    class="sticky-sale-price"
                  >
                    Was {{selectedProduct.sPrice}}
                  </div>
                  <div
                    class="sticky-active-price"
                    itemprop="price"
                    :content="selectedProduct.price"
                    >
                      {{ selectedProduct.price }}
                  </div>
                </div>
                <div v-if="!shopifyEmptyPrices.includes(selectedProduct.sPrice) && selectedProduct.sale" class="sticky-discount">{{ deriveDiscount() }}</div>
              </div>
            </div>
          <button
            type="button"
            class="btn--add-to-cart sticky"
            :class="{ disabled: !selectedProduct.available }"
            @click="addToCart"
            :disabled="!selectedProduct.available"
          >
            <span class="btn__text" v-if="selectedProduct.available">
              Add To Cart • {{selectedProduct.price}}
            </span>
            <span class="btn__text" v-else> SOLD OUT </span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="isTemplated" class="post-atc-cta-wrapper">
      <div class="post-atc-cta">
        Need Help Deciding? 
      </div>
      <a href="https://calendly.com/bmm-design-expert" target="_blank" class="post-cta-action" >
        Schedule a Design Consult
      </a>
    </div>
  </div>
</template>
<script>

import axios from "axios";
import ProductDetails from "./ProductDetails.vue";
export default {
  name: "ProductAddTCartButton",
  components: {
    ProductDetails
  },
  data: function () {
    return {
      cartAddEndpoint: "/cart/add.js?sections=th-cart-drawer,cart-icon-bubble",
      cartEndpoint: "/cart.js",
      errorMessage: "",
      shopifyEmptyPrices: ["$0.00", "$0"],
      IGNORE_SHIPPING_FABRICS: ["Decide Later", "Customer Own Materials"],
      PERCENT_OFF_THRESHOLD: 10,
      BLACK_FRIDAY_THRESSHOLD: 17,
    };
  },
  props: {
    selectedProduct: {
      type: Object,
      default: () => {},
    },
    productAttributes: {
      type: Object,
      default: () => {},
    },
    productType: String,
    hideBorder: Boolean,
    showShipping: Boolean,
    fabrics: {
      type: Array,
      default: () => [],
    },
    shipping: {
      type: Object,
      default: () => {},
    },
    leadTime: {
      type: [String, Number],
    },
    isTemplated: Boolean,
  },
  watch: {
    productAttributes: function () {
      // NOTE THIS IS A TEMP FIX TO GET THIS OUT THE DOOR WITH FABRICS AND FABRIC TYPES
      this.triggerSKUUpdate(this.selectedProduct)
    },
    selectedProduct: function (newVal) {
      if (window) {
        window.activePrice = newVal.price;
        let altPriceElm = document.querySelector(".alternate_price_container");
        if (altPriceElm) {
          altPriceElm.innerText = newVal.price;
        }
      }
      // this.triggerSKUUpdate(newVal)
    },
  },
  computed: {
    productTitle() {
      const decoded = decodeURIComponent(this.selectedProduct.title)
          .replaceAll(/\+/g, " ")
          .replaceAll(/\\/g, "")
      if (decoded.indexOf('(') < 0) return decoded
      return decoded.slice(0, decoded.indexOf('('))
    },
    shippingString() {
      if (this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {
        switch(this.selectedProduct.fabric) {
          case 'Customer Own Materials':
            return "Timeline Available After Material is Received";
          default:
            return "Timeline Available After Material is Selected";
        }
      }
      let activeBaseTime = parseInt(this.shipping.all);
      if (this.shipping[this.selectedProduct.sku]) {
        activeBaseTime = parseInt(this.shipping[this.selectedProduct.sku]);
      }
      let timeString = `${activeBaseTime} Days`;
      if (activeBaseTime > 13) {
        timeString = `${Math.ceil(activeBaseTime / 7)} Weeks`;
      }
      if (this.isTemplated) {
        return `Handcrafted in ${timeString}`;
      }
      return `Ships in ${timeString}`;
    },
  },
  mounted() {
    this.setupSticky()
    document.addEventListener('update-custom-affirm',this.updateCustomAffirm)
    if (window.affirm) {
      const affirmInterval = setInterval(() => {
        // console.log("TESTING")
        if (window.affirm.jsReady()) {
          
          clearInterval(affirmInterval)
          this.updateCustomAffirm()
        }
      })
    }
  },
  created() {},
  methods: {
    triggerSKUUpdate(product) {
      if (!this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {  
        document.dispatchEvent(new CustomEvent('td:sku-updated', {
        detail: {
          sku: product.sku + '_' + this.fabrics.find(
          (fabric) => fabric.title === this.productAttributes["fabric_color"]
        ).sku_code
        }
      }))
      }
      
    },
    deriveDiscount() {
      const activePrice = parseFloat(
        this.selectedProduct.price.replaceAll(/[$,]/gm, "")
      );
      const normalPrice = parseFloat(
        this.selectedProduct.sPrice.replaceAll(/[$,]/gm, "")
      );
      if (!isNaN(normalPrice) && !isNaN(activePrice)) {
        // const percentOff = Math.round(
        //   ((normalPrice - activePrice) / normalPrice) * 100
        // );
        // if (percentOff >= this.BLACK_FRIDAY_THRESSHOLD) {
        //   return `BF Sale`;
        // }
        return `$${normalPrice - activePrice} Off`;
      }
      return "";
    },
    addToCart() {
      if (this.selectedProduct.available) {
        this.errorMessage = "";
        axios
          .post(this.cartAddEndpoint, {
            quantity: 1,
            id: this.selectedProduct.id
              ? this.selectedProduct.id
              : this.selectedProduct.variantId,
            properties: this.derivePropertiesObject(),
          })
          .then((response) => {
            
            const sections  = response.data.sections
            const item = {
              Name: this.selectedProduct,
              ProductID: this.selectedProduct.id
                ? this.selectedProduct.id
                : this.selectedProduct.variantId,
              Categories: this.selectedProduct.categories,
              ImageURL: this.selectedProduct.aImage.src,
              URL: window.location.href,
              Brand: this.selectedProduct.vendor,
              Price: this.selectedProduct.price,
              CompareAtPrice: this.selectedProduct.sPrice,
            };
            if (window._learnq) {
              window._learnq.push(["track", "Added to Cart", item]);
            }
            window.VWO = window.VWO || [];
            window.VWO.event = window.VWO.event || function () {window.VWO.push(["event"].concat([].slice.call(arguments)))};
            window.VWO.event("addToCart");

            axios.get(this.cartEndpoint).then((resp) => {
              document.dispatchEvent(new CustomEvent('td-cart-updated', {
                detail:  {
                  cart: resp.data,
                  sections: sections
                }
              }))
            })
            // window.location.assign(this.cartEndpoint);
          })
          .catch((error) => {
            console.log(error);
            this.errorMessage =
              "An Unexpected Error Has Occured. Please Try Again Later.";
          });
      }
    },
    derivePropertiesObject() {
      const propertyObject = {};
      const propertyKeys = [
        "frame_codes",
        "height",
        "depth",
        "chair_base",
        "bed_size",
        "headboard_height",
        "chair_size",
        "drawer",
        "cushion",
        "leg",
        "fabric",
        "fabric_color",
        "orientation"
      ];
      // Enter these in the proper order of the field
      const productTypeSizeMapping = {
        Chair: ["width_1", "depth_size"],
        Chaise: ["chaise_width", "chaise_length"],
        Pillows: ["pillow_size"],
        Sectional: ["width_1", "width_2"],
        Desk: ["width_1", "depth_size"],
        Ottoman: ["width_1", "depth_size"],
        Loveseat: ["width_1"],
        Sofa: ["width_1"],
        "Modular Piece": ["width_1", "depth_size"],
        "Modular Sectional": ["width_1", "width_2", "width_3"],
        "Sectional with Bumper": ["width_1", "width_2"],
        "Sofa Bed": ["width_1"],
        "Sofa with Bumper": ["width_1"],
        "Sofa with Chaise": ["width_1", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Bumpers": ["width_2", "width_1"],
        "U-Shaped Sectional": ["width_2", "width_1"],
        "Double Chaise Sectional": ["width_2", "chaise_width", "chaise_length"],
        "U-Shaped Sectional With Chaise": ["width_1", "width_2", "width_3"],
        "Sectional With Chaise": ["width_1", "width_2", "width_3"],
      };
      for (const key of propertyKeys) {
        let value = "";
        if (this.selectedProduct[key]) {
          value = this.selectedProduct[key];
        } else if (this.productAttributes[key]) {
          value = this.productAttributes[key];
        }
        if (value) {
          const formattedKey = this.transformText(key);
          if (formattedKey === "Frame Code" && value.includes("|")) {
            value.split("|").forEach((frameCode, index) => {
              const newKey = `${formattedKey} ${index + 1}`;
              propertyObject[newKey] = frameCode.replaceAll(/LGB/gm,'LGA').replaceAll(/CLB-/gm,'CLN-');
            });
          } else if (formattedKey === "Frame Code") {
            propertyObject[formattedKey] = value.replaceAll(/LGB/gm,'LGA').replaceAll(/CLB-/gm,'CLN-');
          } else if (formattedKey=='Fabrics') {
            console.log(this.productAttributes)
            const matchingFabric = this.fabrics.find((fabric) => fabric.title === this.productAttributes["fabric_color"])
            if (matchingFabric && matchingFabric.backorder_date) {
              propertyObject[formattedKey] = value + ` * Back In Stock ${new Date(matchingFabric.backorder_date).toLocaleDateString('en-US',{timeZone: "UTC", year: '2-digit', month: '2-digit', day:'2-digit'})}`;
            } else {
              propertyObject[formattedKey] = value;
            }
          } else {
            propertyObject[formattedKey] = value;
          }
        }
      }
      if (productTypeSizeMapping[this.productType]) {
        propertyObject["Size"] = this.deriveSizeField(
          productTypeSizeMapping[this.productType]
        );
        propertyObject["_SizeDetails"] = this.deriveSizeDetails(productTypeSizeMapping[this.productType])
      }

      if (this.productAttributes["fabric_color"]) {
        propertyObject["Fabric Code"] = this.fabrics.find(
          (fabric) => fabric.title === this.productAttributes["fabric_color"]
        ).sku_code;
      }
      if (this.IGNORE_SHIPPING_FABRICS.includes(this.selectedProduct.fabric)) {
        switch(this.selectedProduct.fabric) {
          case 'Customer Own Materials':
            propertyObject["_leadTime"] = 9999998;
            break;
          default:
            propertyObject["_leadTime"] = 9999999;
            break;
        }
      } else {
        let productTime = parseInt(this.shipping[this.selectedProduct.sku]);
        let leadTime = parseInt(this.leadTime);
        if (!isNaN(leadTime) && leadTime > productTime) {
          propertyObject["_leadTime"] = leadTime;
        } else {
          propertyObject["_leadTime"] = productTime;
        }
      }
      return propertyObject;
    },
    sizeDescriptors() {
      if (['Sofa', 'Loveseat', 'Sofa with Bumper', 'Corner'].includes(this.productType)) {
        return ['Wide']
      } else if (['Chair'].includes(this.productType)) {
        return ['Wide', 'Deep']
      } else if (['U-Shaped Sectional', 'U-Shaped Sectional With Bumpers'].includes(this.productType)) {
        return ['Wide', "Corner Side"]
      } else if (['Double Chaise Sectional','Sofa with Chaise'].includes(this.productType)) {
        return ['Width', "Chaise Width", "Chaise Length"]
      } else if ('Sectional' === this.productType) {
        return ['Sofa Side', "Corner Side"]
      } else if ('Sectional with Bumper' === this.productType) {
        return ['Sofa Side', "Bumper Side"]
      } else if ('Chaise' === this.productType) {
        return ['Width', "Length"]
      } else if ('Desk' === this.productType) {
        return ['Width', "Depth"]
      } else if ('Sofa Bed' === this.productType) {
        return ['Width']
      } 
      return []
    },
    transformText(key) {
      let formattedKey = key
        .split("_")
        .map((part) => part[0].toUpperCase() + part.substring(1))
        .join(" ");
      if (formattedKey === "Frame Codes") return "Frame Code";
      if (formattedKey === "Fabric") return "Fabric Category";
      if (formattedKey === "Fabric Color") return "Fabrics";
      if (formattedKey === "Bed Size") return "Size";
      if (formattedKey === "Orientation" && this.productType === "Chaise")
        return "Chaise Facing";
      if (formattedKey === "Orientation" && this.productType === "Sectional")
        return "Corner On";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sectional with Bumper"
      )
        return "Bumper";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sofa with Bumper"
      )
        return "Bumper Orientation";
      if (
        formattedKey === "Orientation" &&
        this.productType === "Sofa with Chaise"
      )
        return "Chaise";
      return formattedKey;
    },
    deriveSizeDetails(productFields) {
      let sizeDetail = ''
      const descriptors = this.sizeDescriptors()
      const fieldValues = [];
      for (const field of productFields) {
        if (this.selectedProduct[field]) {
          if (field === 'pillow_size') {
            fieldValues.push(`${this.selectedProduct[field]}`);
          } else { fieldValues.push(`${this.selectedProduct[field]}"`); }
        }
      }
      
      fieldValues.forEach((fieldVal,  index) => {
        sizeDetail += `${fieldVal} - ${descriptors[index]} |`
      }) 
      if (sizeDetail.length > 1) {
        // Stripping out the last one
        sizeDetail = sizeDetail.substring(0,sizeDetail.length - 1)
      }
      return sizeDetail
    },
    deriveSizeField(productFields) {
      const fieldValues = [];
      for (const field of productFields) {
        if (this.selectedProduct[field]) {
          if (field === 'pillow_size') {
            fieldValues.push(`${this.selectedProduct[field]}`);
          } else { fieldValues.push(`${this.selectedProduct[field]}"`); }
        }
      }
      if (fieldValues.length === 1) {
        return fieldValues[0];
      }
      return fieldValues.join(" x ");
    },
    setupSticky() {
      if (document.querySelector('#launcher')) {
        document.querySelector('#launcher').style.bottom = '85px'
      }
      // NOTE turned off so this can always be sticky
       const stickyClass = 'sticky-atc-stuck';
       const sentinel = this.$refs.atcButton;
       const sticky = this.$refs.stickyContainer;
       if (sentinel && sticky) {
         const handler = (entries) => {
           if (!entries[0].isIntersecting) {
             if (window.scrollY >= sentinel.offsetTop + sentinel.offsetHeight) {
               if (!sticky.classList.contains(stickyClass)) {
                 sticky.classList.add(stickyClass);
               }
               if (document.querySelector('#launcher') && window.matchMedia("(max-width: 768px)").matches) {
                 document.querySelector('#launcher').style.bottom = '85px'
               }
             }
           } else {
             sticky.classList.remove(stickyClass);
             if (document.querySelector('#launcher')) {
                 document.querySelector('#launcher').style.bottom = '0'
             }
           }
         };

        if (sentinel) {
           const options = {};
           this.observer = new window.IntersectionObserver(handler, options);
           this.observer.observe(sentinel);
         }
       }
    },
    updateCustomAffirm() {
      setTimeout(() => {
        const affirmContent = document.querySelector('.affirm-as-low-as:not(.td--cart__affirm)')
        if (affirmContent && affirmContent.childElementCount) {
          const copy = affirmContent.outerHTML.replace('/mo','/month')
          this.$refs.promoWrapper.innerHTML = ''
          this.$refs.promoWrapper.innerHTML = copy
          if (!this.$refs.promoWrapper.classList.contains('active')) {
            this.$refs.promoWrapper.classList.add('active')
          }
        }
      }, 1000)

      
    }
  },
};
</script>
<style>
.__affirm-logo.__affirm-logo-black::after {
  color: #fff;
}
.__affirm-logo::after {
  content: "";
}
.__affirm-logo::after, .__affirm-logo.__ligature__affirm_short_logo__::after {
  position: absolute;
  left: 0;
  bottom: 0;
}
.__affirm-logo {
  font-family: "affirm" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  font-variant-ligatures: normal;
  text-transform: none;
  line-height: 1;
  position: relative;
  white-space: nowrap;
  letter-spacing: 0;
  -ms-font-feature-settings: "liga" 1;
  -webkit-font-feature-settings: "liga";
  font-feature-settings: "liga";
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 20px;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  text-size-adjust: 100%;
  color: #fff;
}
.promo-component-wrapper a {
  display: none;
}
</style>
<style scoped>
.post-cta-action {
  border: 1px solid #31382d;
  border-radius: 4px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  padding: 23px;
  transition: 0.2s ease-in-out;
}
.post-cta-action, .post-cta-action:visited {
  color: #31382d;
}
.post-cta-action:hover {
  background-color: #31382d;
  color: #F0F0F0;
}
.post-atc-cta {
  text-align: left;
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  margin-bottom: 10px;
}

.post-atc-cta-wrapper {
  border-top: 1px solid #cbc8c3;
  padding: 22px 20px;
}
.promo-component-wrapper {
  min-width: 155px;
  padding: 0;
  /* min-height: 56px; */
  border-radius: 6px;
  background-color: #494AF4;
  background-image: none;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: .2s ease-in-out;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  margin-top: 8px;
  transition: 0.3s ease-in-out;
  overflow: hidden;
  max-height: 0;
}
.promo-component-wrapper.active {
  max-height: 56px;
    border: 1px solid #494AF4;
}

.sticky-atc-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  transition: 0.2s ease-in-out;
  transform: translateY(100%);
  pointer-events: none;
}
.sticky-atc-stuck {
  transform: translateY(0);
}
.sticky-atc {
  max-width: 1200px;
  background: #fff;
  margin: 0 auto;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  box-shadow: 0 0 14px 4px rgba(0,0,0,.2);
  border-radius: 3px;
  pointer-events: all;
}
.sticky-discount {
  background: #57663C;
  border-radius: 78px;
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  color: #fff;
  flex-shrink: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
}
.sticky-atc-heading {
  font-family: var(--oddit-heading-font);
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
}
.sticky-price-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.sticky-price-details {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.sticky-sale-price {
  font-weight: 500;
  font-size: 12px;
  line-height: 140%;
  text-decoration: line-through;
  color: #A1A1A1;
}
.sticky-active-price {
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #57663C;
}
.btn--add-to-cart.sticky {
  font-size: 16px;
  line-height: 140%;
  min-width: unset;
  min-height: unset;
  max-width: 55%;
  letter-spacing: -0.25px;
  padding: 14px 15px;
  max-height: 52px;
}
.visually-hidden {
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  position: absolute;
  height: 1px;
  width: 1px;
}
.shipping-link_container {
  margin-bottom: 15px;
}
.shipping-link_link {
  color: #31382d;
}
.shipping-link_link:hover {
  color: #3a3830;
}
.hide-border {
  border: none !important;
}
.product-single__price {
  margin-bottom: 1rem;
  color: #393534;
  font-family: var(--oddit-heading-font);
  font-size: 2.125rem;
  font-weight: 600;
  letter-spacing: 0.25px;
  line-height: 41px;
  opacity: 0.87;
  display: block;
}
.btn--add-to-cart {
  min-width: 155px;
  padding: 0;
  /* min-width: 240px; */
  min-height: 56px;
  border-radius: 6px;
  border: 1px solid #31382d; 
  background-color: #31382d;
  background-image: none;
  color: #fff;
  font-family: var(--oddit-main-font);;
  font-weight: 400;
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0.25px;
  flex: auto;
  cursor: pointer;
  -webkit-appearance: button;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  transition: 0.2s ease-in-out;
}

.btn--add-to-cart:not(.disabled):hover {
  background-color: #fff;
  border-color: #31382d;
  color:#31382d;
}
.btn--add-to-cart.disabled {
  color: #bfbfbf;
}
.product-single__price--compare-at {
  font-size: 1rem;
  font-family: var(--oddit-main-font);;
  line-height: 1.333;
  letter-spacing: 0.4px;
  color: #7c7473;
  opacity: 0.87;
  padding-right: 5px;
  display: inline-block;
  text-decoration: line-through;
  font-weight: 400;
  font-style: normal;
}
.product-discount-percent {
  margin-left: 10px;
  font-size: 1rem;
  font-family: var(--oddit-main-font);;
  line-height: 1.333;
  letter-spacing: 0.4px;
  padding-right: 5px;
  display: inline-block;
  font-weight: 400;
  font-style: normal;
}
.error-message_container {
  padding: 1rem 1rem 0 1rem;
  display: flex;
  justify-content: center;
}
.error-message_message {
  max-width: 30ch;
  font-weight: 600;
  color: #b91c1c;
}
.disabled {
  user-select: none;
  pointer-events: none;
  background-color: #eee;
  color: #bfbfbf;
  border-color: #ccc;
}
.atc-wrapper {
  border-top: 1px solid #cbc8c3;
  padding: 1rem 0;
  align-items: center;
  border-bottom: 0;
  text-align: left;
  margin: 0 20px;
}
.shipping_length {
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  margin-top: 12px;
}
/* This gets us around the spacing in the page */
@media screen and (min-width: 460px) {
  .atc-wrapper {
    border-bottom: 1px solid #cbc8c3;
  }
}
@media screen and (min-width: 768px) {
  .atc-wrapper {
    border: 1px solid #cbc8c3;
    margin: 0;
    padding: 16px 24px;
  }
  .sticky-atc {
    padding: 12px;
    max-width: 460px;
  }
  .sticky-atc-wrapper {
    z-index: 10;
  }
  .post-atc-cta {
    font-size: 24px;
    margin-bottom: 15px;
  }
  .shipping_length {
    font-size: 16px;
  }

  .post-atc-cta-wrapper {
    padding: 22px 24px 26px;
    border: 1px solid #cbc8c3;;
    border-top: 0;
  }
}
@media screen and (min-width: 1024px) {
  .atc-wrapper {
    padding: 1.5rem 1.6rem;
  }
}
</style>
